import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { Group } from "../../schema/types/group/entity";

export const groupApi = createApi({
  reducerPath: "groupApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Group"],
  endpoints: (builder) => ({
    getGroup: builder.query<Group, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "Group", id: link }],
    }),
  }),
});

export const { useGetGroupQuery } = groupApi;
